export const activeCounterTableHeaders = ['ID', 'Client name', 'Active users'];